import { render, staticRenderFns } from "./ChannelBadge.vue?vue&type=template&id=697cb4d8&scoped=true&"
import script from "./ChannelBadge.vue?vue&type=script&lang=js&"
export * from "./ChannelBadge.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBadge.vue?vue&type=style&index=0&id=697cb4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697cb4d8",
  null
  
)

export default component.exports